import Catalog from './Catalog'

export default function Components(Vue) {
  Vue.component('project-catalog', Catalog)
}
